import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DashboardTeamMemberResponse } from '../../../services/response/dashboard-team-response';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

@Component({
   selector: 'app-dashboard-team',
   standalone: true,
   imports: [CommonModule, DashboardCardComponent],
   templateUrl: './dashboard-team.component.html',
   styleUrls: ['./dashboard-team.component.scss']
})
export class DashboardTeamComponent {
   @Input() team: DashboardTeamMemberResponse[] = [];
   @Input() loading = false;
   @Input() error = false;

   expanded = false;

   get visibleTeam(): DashboardTeamMemberResponse[] {
      return this.expanded ? this.team : this.team.slice(0, 5);
   }

   get hasMoreTeamMembers(): boolean {
      return this.team.length > 5;
   }

   toggleExpanded(): void {
      this.expanded = !this.expanded;
   }
}
